// TODO: check why this two files are very similar src\reducers\Reconciliations\updatePrimaryAccount.js
// Ideal should have 1 if they are going to update the same object.
// Location should be in normalizers folder. #Swarnabh or #Rodri

export default (currentAccounts, newGroupComponentAccount) => {
	const resp = currentAccounts.map((account) => {
		if (account.accountId === newGroupComponentAccount.primaryAccountId) {
			const newAccount = {
				...account,
				rationale: newGroupComponentAccount.rationale === undefined ? null : newGroupComponentAccount.rationale,
				...newGroupComponentAccount,
				rationaleModifyBy: newGroupComponentAccount.modifyUser,
				rationaleModifyDate: newGroupComponentAccount.modifyDate
			};

			return newAccount;
		}
		return account;
	});
	return resp;
};
